import { GuildSideBar } from './GuildSideBar';
import { Guild } from '../../../../utils/types';
import sidebar from '../styles/sidebar.module.scss'


const MenuPage = ({ client, guilds, playerGuild, updatePlayerGuild, user }: any) => {

  const handleClick = (guild: Guild) => {
    updatePlayerGuild(guild);
    console.log(guild)
    client.send(JSON.stringify({ message: "status", guild: guild?.id, user: user?.id }))
  };

  return (
    <>
      <div className={sidebar.container}>
        <div className={sidebar.sideconstruct}>
          {guilds && guilds.map((guild: any) => (
            <div key={guild.id} onClick={() => handleClick(guild)}>
              <GuildSideBar guild={guild} selected={guild.id === playerGuild?.id ? true : false}/>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default MenuPage